<template>
  <div>
    <main style="max-height: calc(100svh - 150px);">
      <div class="WorkM_MainArea">
        <b-container fluid style="max-width: 700px">
          <div class="WorkM_CompleteAporoval">
            <b-tabs 
            fill
            class="mt-3"
            active-nav-item-class="font-weight-bold"
            pills
            justified
            >
              <!-- 申請承認 -->
              <b-tab @click="getApprovalApplicationInfo()" title="事前申請" title-link-class="border border-primary mr-2" active>
                <ApprovalApplicationHistory ref="ApprovalApplicationHistory" :isApprovalHistory=false></ApprovalApplicationHistory>
              </b-tab>
              <!-- 報告承認 -->
              <b-tab @click="getApprovalWorkInfo()" title="報告" title-link-class="border border-primary">
                <ApprovalWorkHistory ref="ApprovalWorkHistory" :isApprovalHistory=false></ApprovalWorkHistory>
              </b-tab>
            </b-tabs>
          </div>
        </b-container>
      </div>
    </main>
  </div>
</template>

<script>
// import moment from "moment";
import ApprovalApplicationHistory from "../components/Parts/ApprovalApplicationHistory";
import ApprovalWorkHistory from "../components/Parts/ApprovalWorkHistory";
export default {
  name: "ApplicationHistory",
  components: {ApprovalApplicationHistory, ApprovalWorkHistory},
  data() {
    return {
      systemVersion: null,
    };
  },
  computed: {},
  watch: {},
  mounted: function () {
    this.systemVersion = this.$store.getters.getSystemVersion;
    this.$refs.ApprovalApplicationHistory.getMyApprovalApplicationInfo();
  },

  methods: {
    getApprovalApplicationInfo: function(){
      this.$refs.ApprovalApplicationHistory.getMyApprovalApplicationInfo();
    },
    getApprovalWorkInfo: function(){
      this.$refs.ApprovalWorkHistory.getMyApprovalWorkInfo();
    }
  },
};
</script>
<style>
.WorkM_CompleteAporoval {
  padding: 0 1rem;
}

.ApprovalSelectArea {
  margin-top: 0.5rem;
}
  
.WorkM_CompleteAporoval .ApprovalFooter{
  margin-bottom: 50px !important; 
  background-color: #ececec !important;
}
.WorkM_CompleteAporoval .ApprovalDetailItemConstruction{
  width:auto;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.WorkM_CompleteAporoval .ApprovalDateApprovalApplication{
  flex-wrap:wrap;
}
</style>
